import WordDocColor from './WordDocColour.svg';
import WordDocDark from './WordDocDark.svg';
import WordDocLight from './WordDocLight.svg';
export const wordDoc = { color: WordDocColor, dark: WordDocDark, light: WordDocLight };
//# sourceMappingURL=index.js.map